import { DeliveryStatusForUser } from '@/features/dashboard/messages/types/DeliveryStatusForUser.ts';
import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { HelpCircle, CheckCircle, XCircle } from 'lucide-react';

export const deliveryStatusForUserLabels: Record<
  DeliveryStatusForUser,
  string
> = {
  [DeliveryStatusForUser.UNKNOWN]: 'Nieznany',
  [DeliveryStatusForUser.DELIVERED]: 'Dostarczono',
  [DeliveryStatusForUser.ERROR]: 'Błąd',
};

export const deliveryStatusForUserTableConfig: EnumTableConfig = {
  [DeliveryStatusForUser.UNKNOWN]: {
    ...toneEnumConfig(
      deliveryStatusForUserLabels[DeliveryStatusForUser.UNKNOWN],
      'neutral',
      HelpCircle,
    ),
    tooltip: 'Nieznany',
    displayMode: 'icon',
  },
  [DeliveryStatusForUser.DELIVERED]: {
    ...toneEnumConfig(
      deliveryStatusForUserLabels[DeliveryStatusForUser.DELIVERED],
      'success',
      CheckCircle,
    ),
    tooltip: 'Dostarczono',
    displayMode: 'icon',
  },
  [DeliveryStatusForUser.ERROR]: {
    ...toneEnumConfig(
      deliveryStatusForUserLabels[DeliveryStatusForUser.ERROR],
      'error',
      XCircle,
    ),
    tooltip: 'Błąd dostarczenia',
    displayMode: 'icon',
  },
};

export const getDeliveryStatusForUserLabel = (status: string): string => {
  return deliveryStatusForUserLabels[status as DeliveryStatusForUser] ?? status;
};
